import React from "react";
import { TabPanel, TabView } from "primereact/tabview";
import useSessionState from "../hooks/useSessionState";
import JiraCards from "./JiraCards";
import constantes from "../catalogos/constantes";
import useSeguridad from "../Seguridad/useSeguridad";
import JiraIndicadores from "./JiraIndicadores";
const JiraCardsSecciones = () => {
    const seguridad = useSeguridad();
    const soloLectura = !seguridad.esEditable(constantes.menus.movimientos);
    const [activeIndex, setActiveIndex] = useSessionState('tabSeguimiento', 0);

    return (
        <>
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="main-tab-view">
          <TabPanel  headerStyle ={(seguridad.tieneAcceso(constantes.menus.movimientosSeccion) || soloLectura )?  {display:"inline"} : {display:"none"} } header="Tickets">
                <JiraCards  name="Tickets" esSeccionAutorizar={false} soloLectura={soloLectura} />
            </TabPanel>
            <TabPanel  headerStyle ={seguridad.tieneAcceso(constantes.menus.movimientosPorAutorizar) ?  {display:"inline"} : {display:"none"} } header="Backlog">
                <JiraCards name="Backlog"  esSeccionAutorizar={true} soloLectura={soloLectura}/>
            </TabPanel>
            <TabPanel
                header="Dashboard TI"
                headerStyle={
                 
                    { display: "inline" }
                     
                }
            >
                <JiraIndicadores
                    soloLectura={soloLectura}
                />
            </TabPanel>
        </TabView>
         </>
    )
};

export default JiraCardsSecciones;
